import React from 'react';
import { Navigate } from 'react-router-dom';
import { useClientAuth } from '../context/ClientAuthContext';
import { Container, Spinner } from 'react-bootstrap';

const ClientProtectedRoute = ({ children }) => {
  const { isClientAuthenticated, loadingClient } = useClientAuth();

  if (loadingClient) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }

  if (!isClientAuthenticated) {
    return <Navigate to="/client" replace />;
  }

  return children;
};

export default ClientProtectedRoute;
